import { apiClient } from './api';
import {
  ImportSource,
  CreateImportSourceRequest,
  UpdateImportSourceRequest,
  ImportTestResponse,
} from '../types/api';

export const importSourcesService = {
  getAll: async (): Promise<ImportSource[]> => {
    const { data } = await apiClient.get('/import-sources');
    return data;
  },

  getById: async (id: number): Promise<ImportSource> => {
    const { data } = await apiClient.get(`/import-sources/${id}`);
    return data;
  },

  create: async (request: CreateImportSourceRequest): Promise<ImportSource> => {
    const { data } = await apiClient.post('/import-sources', request);
    return data;
  },

  update: async (id: number, request: UpdateImportSourceRequest): Promise<void> => {
    await apiClient.put(`/import-sources/${id}`, request);
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/import-sources/${id}`);
  },

  test: async (id: number): Promise<ImportTestResponse> => {
    const { data } = await apiClient.post(`/import-sources/${id}/test`);
    return data;
  },

  trigger: async (id: number): Promise<any> => {
    const { data } = await apiClient.post(`/import-sources/${id}/trigger`);
    return data;
  },
};
